import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-constants';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/_list/',
)({
  validateSearch: zodValidator(SearchSchema),
});
